"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonAction = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _polished = require("polished");

var _styles = require("./shared/styles");

var _Icon = require("./Icon");

var _TooltipNote = require("./tooltip/TooltipNote");

var _WithTooltip = _interopRequireDefault(require("./tooltip/WithTooltip"));

var _excluded = ["children", "icon", "isActive", "tooltip"];
var StyledButton = /*#__PURE__*/(0, _theming.styled)("button", process.env.NODE_ENV === "production" ? {
  target: "ezw767d0"
} : {
  target: "ezw767d0",
  label: "StyledButton"
})("border:0;border-radius:5px;cursor:pointer;display:flex;gap:6px;align-items:center;overflow:hidden;padding:7px;position:relative;text-align:center;text-decoration:none;transition:all 150ms ease-out;vertical-align:top;white-space:nowrap;user-select:none;opacity:1;margin:0;background-color:transparent;font-size:", _styles.typography.size.s2, "px;line-height:14px;font-weight:", _styles.typography.weight.regular, ";color:", _styles.color.mediumdark, ";", function (props) {
  return props.isActive && "\n      background-color: ".concat((0, _polished.transparentize)(0.93, _styles.color.secondary), ";\n      color: ").concat(_styles.color.secondary, ";\n    ");
}, " &:hover{color:", _styles.color.secondary, ";background-color:", (0, _polished.transparentize)(0.86, _styles.color.secondary), ";}");

var ButtonAction = function ButtonAction(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      tooltip = _ref.tooltip,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (tooltip) return /*#__PURE__*/_react["default"].createElement(_WithTooltip["default"], (0, _extends2["default"])({
    tooltip: /*#__PURE__*/_react["default"].createElement(_TooltipNote.TooltipNote, {
      note: tooltip
    }),
    hasChrome: false,
    delayShow: 600
  }, rest), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    isActive: isActive,
    as: "div"
  }, icon && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: icon
  }), children));
  return /*#__PURE__*/_react["default"].createElement(StyledButton, (0, _extends2["default"])({
    isActive: isActive
  }, rest), icon && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: icon
  }), children);
};

exports.ButtonAction = ButtonAction;